'use client';
import { jsx } from 'react/jsx-runtime';
import { TagCloseIcon } from './tag-close-icon.mjs';
import { useTagStyles } from './tag-context.mjs';
import { forwardRef } from '../system/forward-ref.mjs';
import { chakra } from '../system/factory.mjs';

const TagCloseTrigger = forwardRef(
  function TagCloseTrigger2(props, ref) {
    const { isDisabled, children = /* @__PURE__ */ jsx(TagCloseIcon, {}), ...rest } = props;
    const styles = useTagStyles();
    return /* @__PURE__ */ jsx(
      chakra.button,
      {
        ref,
        "aria-label": "close",
        ...rest,
        type: "button",
        disabled: isDisabled,
        __css: styles.closeTrigger,
        children
      }
    );
  }
);
TagCloseTrigger.displayName = "TagCloseTrigger";

export { TagCloseTrigger };
